import { CustomerModel } from "@models/customer/customerModel"

export class ApprovalConfigurationPositionModel {
  id: any
  name: any
  requestConfigurationId: any
  userIds?: any[]
  constructor() {
    this.id = undefined
    this.requestConfigurationId = undefined
    this.name = ""
    this.userIds = []
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ApprovalConfigurationPositionModel(), obj)

    newObj.flowId = obj.id
    newObj.id = obj.approvalPositionId // lấy id là approvalPositionId, update dùng approvalPositionId
    newObj.name = obj.approvalPosition?.name
    newObj.userIds = obj.approvalPosition?.userIds
    newObj.users = obj.approvalPosition?.approvalUsers?.map((item) => {
      return { id: item?.userId, name: item?.user?.displayName }
    })

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
export class ApprovalConfigurationModel {
  constructor() {}

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ApprovalConfigurationModel(), obj)

    newObj.data = ApprovalConfigurationPositionModel.assigns(obj.flows)

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class customerUpdateRequestModel {
  updateData?: any
  constructor() {
    this.updateData = {}
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new customerUpdateRequestModel(), obj)

    newObj.updateData = CustomerModel.assign(obj.updateData)

    newObj.data = CustomerModel.assign(obj.data)
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

/** Một hợp đồng bị ảnh hưởng khi duyệt thay đổi thông tin định danh KHHH (SKLCRMF01-447). */
export interface ICustomerIdentityPropagationContract {
  contractId: number
  contractCode?: string | null
  projectId?: number | null
  projectName?: string | null
  /** null = không phân giải được pháp nhân (định danh vẫn lan trong CRM nhưng không đẩy được Phoebus). */
  companyId?: number | null
  companyCode?: string | null
  /** null = chưa có ECI ở pháp nhân này. */
  externalCustomerCode?: string | null
  /** true ⇒ lượt duyệt sẽ TẠO MỚI bản ghi ở hệ thống ngoài. */
  willCreateEntityContactInfo: boolean
}

export interface ICustomerIdentityPropagationScope {
  existingCustomerId: number
  totalContracts: number
  totalCompanies: number
  totalContractsWithoutCompany: number
  contracts: ICustomerIdentityPropagationContract[]
}

export interface IApprovalConfigurationAvailability {
  hasConfiguration: boolean
  /** Khoá i18n lý do không gửi duyệt được; null khi hasConfiguration = true. */
  reasonKey: string | null
  requestConfigurationId: number | null
}
